import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
const INSTALL_PROMPT_READY_EVENT = "installpromptready";
const APP_INSTALLED_EVENT = "appinstalled";
const GESTURE_EVENTS = ["pointerdown", "keydown"];
const ARM_DELAY_MS = 30_000;

/** Opens the install dialog after ARM_DELAY_MS, on the next interaction. */
export const useInstallPrompt = () => {
  const $ = _c(5);
  const [canInstall, setCanInstall] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const sync = () => setCanInstall(!!window.__installPrompt);
      sync();
      window.addEventListener(INSTALL_PROMPT_READY_EVENT, sync);
      window.addEventListener(APP_INSTALLED_EVENT, sync);
      return () => {
        window.removeEventListener(INSTALL_PROMPT_READY_EVENT, sync);
        window.removeEventListener(APP_INSTALLED_EVENT, sync);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[2] !== canInstall) {
    t2 = () => {
      if (!canInstall) {
        return;
      }
      const open = () => {
        window.__installPrompt?.prompt();
        window.__installPrompt = undefined;
        setCanInstall(false);
      };
      const arm = () => GESTURE_EVENTS.forEach(event => document.addEventListener(event, open, {
        once: true
      }));
      const timeout = setTimeout(arm, ARM_DELAY_MS);
      return () => {
        clearTimeout(timeout);
        GESTURE_EVENTS.forEach(event_0 => document.removeEventListener(event_0, open));
      };
    };
    t3 = [canInstall];
    $[2] = canInstall;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
};